import { Record } from '@redge-media/fo-js-sdk';
import { cover } from '@/shared/libs/helpers';
import { fillInUniqueId } from '@/shared/utils';
import Products from '../products/products';

const Section = Record.mixin(cover).extend({
  set(key, value, opts = {}) {
    const data = Record.prototype.set.call(this, key, value, opts);
    const elements = data.elements;

    if (!(elements instanceof Products)) {
      data.elements = new Products({ isFetched: true });
      data.elements.add(elements);
    }

    data.configuration = data.configuration || {};
    data.configuration.elements = data.configuration.elements || [];

    fillInUniqueId(data.configuration.elements);
    data.configuration.elements.forEach((element) => {
      fillInUniqueId(element.elements);
    });

    return data;
  },
});

export default Section;
